<template>
  <div class="login-container">
    <div class="col-xs-12">
      <div class="login">

        <!-- Begin Client Logo -->
        <div class="logo"></div>

        <div class="header-bar text-center mcBG">
          <img src="static/img/i3v_icon_white.png">
          <h1>uManage Mobile{{ sandboxTitle }}</h1>
        </div>

        <div class="form-container">
          <h2 class="scText">Login</h2>

          <!-- Login Error START -->
          <transition name="fade">
            <div v-if="loginError">
              <div class="error-message">
                There was an issue logging in. Please check your Username and Password and try again.
              </div>
            </div>
          </transition>
          <!-- Login Error END -->

          <!-- Login Form START -->
          <form @submit.prevent="login">
            <div class="form-group">
              <input name="username" class="form-control" v-model="user" type="text" placeholder="Username"
                required="" />
            </div>
            <div class="form-group">
              <input name="password" class="form-control" v-model="pass" type="password" placeholder="Password"
                required="" />
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-primary mcBG scBGHover">
                Login <span v-show="loginLoading"> <i class="fa fa-refresh fa-spin" aria-hidden="true"></i></span>
              </button>
            </div>
          </form>
          <!-- Login Form END -->

        </div>

        <pre v-show="false">
        {{ $data }}
      </pre>

      </div>

    </div>
  </div>
</template>

<script>




import Store from '../store'
import User from '../services/user'
import { getWOConfigs } from '../services/padre.js';
import Dropzone from 'vue2-dropzone'
let request = require('superagent')
let _ = require('highland')

export default {

  name: 'Login',
  components: {
    Dropzone
  },
  created() {
  },
  methods: {
    login() {
      this.$validator.validateAll().then(success => {

        this.loginLoading = true;
        this.loginError = false;

        // TODO: Retrieves the system code from the client.js file.
        User.setUser(this.user, this.pass, this.systemCode)
        User.login(
          // success
          (err, res) => {
            this.$router.push('/')
          },
          // failure
          (err, res) => {
            console.log('Login error: ' + err)
            this.loginError = true;
            this.loginLoading = false;
          }
        )
      });
    },
  },
  data() {
    return {
      user: '',
      pass: '',
      loginError: false,
      logout: false,
      loginLoading: false,
      sandboxTitle: (process.env.NODE_ENV === 'production') ? "" : " : Test",
      logoSrc: ''
    }
  },
  async beforeMount() {
    let woConfigs = await getWOConfigs();

    this.logoSrc = woConfigs.logoUrl;
    this.systemCode = woConfigs.systemCode;
  }
}
</script>

<style scoped>
.login-container {
  margin: 0 auto;
  max-width: 768px;
}

.login-container .col-xs-12 {
  padding-left: 0;
  padding-right: 0;
}

.login {
  padding-top: 20px;
}

.login img {
  max-width: 180px;
}

.header-bar {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  padding: 10px 0;
}

.header-bar img {
  display: inline-block;
  max-width: 50px;
  max-height: 25px;
}

.header-bar h1 {
  color: #fff;
  display: inline-block;
  font-size: 22px;
  margin: 0 0 0 5px;
  padding: 0;
}

.form-container {
  background: #f8f8f8;
  padding: 15px;
  text-align: center;
}

.form-container h2 {
  font-family: 'ralewayblack';
  font-size: 24px;
  margin: 10px 0 20px;
  padding: 0;
  text-transform: uppercase;
}

.form-container .form-group {
  margin-bottom: 30px;
}

.form-container .form-control {
  background: #eaedf0;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  border-radius: 0px;
  border: 0;
  display: inline-block;
  font-size: 16px;
  font-family: 'open_sanssemibold';
  height: 55px;
  max-width: 400px;
  text-align: center;
}

.form-container .validation-error {
  color: #cc0000;
  display: block;
  font-size: 11px;
  font-family: 'open_sanssemibold';
  margin-top: 3px;
}

.form-container .btn {
  border: 0;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  border-radius: 0px;
  color: #fff;
  display: inline-block;
  font-family: 'ralewayblack';
  font-size: 20px;
  height: 55px;
  line-height: 20px;
  max-width: 360px;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  text-transform: uppercase;
  width: 100%;
}

.form-container .btn i {
  margin-left: 5px;
}

.error-message {
  background: url(../../static/img/error-stripes.jpg);
  border: 2px solid #cc0000;
  color: #333;
  font-family: 'open_sanssemibold';
  font-size: 16px;
  margin-bottom: 25px;
  padding: 15px;
}

@media only screen and (min-width : 768px) {
  .header-bar {
    -webkit-border-top-left-radius: 8px;
    -webkit-border-top-right-radius: 8px;
    -moz-border-radius-topleft: 8px;
    -moz-border-radius-topright: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .form-container {
    -webkit-border-bottom-right-radius: 8px;
    -webkit-border-bottom-left-radius: 8px;
    -moz-border-radius-bottomright: 8px;
    -moz-border-radius-bottomleft: 8px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?2046cf58